














import XInput from '@/components/atoms/Input/XInput.vue'
import ZipcodeMixin from '@/mixin/zipcodeMixin'

type Props = {
  value: string
  rules: string | object
  addressLoadable: boolean
}

type Data = {
  error: string | null
}

type Computed = {
  zipcode: string
  computedRules: string
}

type Methods = {
  detectAddress: (zipcode: string) => void
  inputManually: (value: string) => void
  setError: (error: Error) => void
  resetError: () => void
}

export default ZipcodeMixin.extend<Data, Methods, Computed, Props>({
  inheritAttrs: false,
  name: 'XZipInput',
  components: { XInput },
  props: {
    value: {
      type: String,
    },
    rules: {
      type: [String, Object],
      required: false,
    },
    addressLoadable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { error: null }
  },
  computed: {
    zipcode: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    computedRules() {
      return `zip${this.rules ? '|' + this.rules : ''}`
    },
  },
  methods: {
    inputManually(value: string) {
      this.detectAddress(value)
    },
    detectAddress(zipcode: string) {
      if (!this.addressLoadable) {
        return
      }

      if (this.zipcode === zipcode) {
        return
      }

      this.loadAddress(zipcode)
        .then((address) => {
          if (address) {
            this.$emit('load:address', address)
            this.resetError()
          }
        })
        .catch((error) => this.setError(error))
    },
    setError(error: Error) {
      this.error = error.message
    },
    resetError() {
      this.error = null
    },
  },
})
